<template>
  <b-modal ref="modal" id="createTemplateModal" hide-footer hide-header body-class="p-0">
    <div class="modal-card card">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="card-header-title" id="exampleModalCenterTitle">New Template</h4>
          </div>
          <div class="col-auto">
            <button @click="close" type="button" class="close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body" style="max-height: 650px">
        <div class="row">
          <div class="col-12">
            <CreateAutoTemplateForm
              :modal="true"
              @saved="onCreateTemplate"
              v-if="parentComponent === 'responses'"
            />
            <CreateTemplateForm :modal="true" @saved="onCreateTemplate" v-else />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import CreateTemplateForm from '@/components/Modules/Template/CreateTemplate/CreateTemplateForm.vue'
import CreateAutoTemplateForm from '@/components/Modules/Template/CreateTemplate/CreateAutoTemplateForm'

export default {
  name: 'CreateTemplateModal',
  components: {
    CreateTemplateForm,
    CreateAutoTemplateForm
  },
  props: {
    parentComponent: {
      type: String // i.e. 'responses', 'templates'
    }
  },
  data: () => ({}),
  methods: {
    onCreateTemplate(template) {
      this.$emit('added', template)
      this.close()
    },
    open() {
      this.$refs.modal.show()
    },
    close() {
      this.$refs.modal.hide()
    }
  }
}
</script>
